import { render, staticRenderFns } from "./UploadTrackForm.vue?vue&type=template&id=5348c4d6&scoped=true&"
import script from "./UploadTrackForm.vue?vue&type=script&lang=js&"
export * from "./UploadTrackForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadTrackForm.vue?vue&type=style&index=0&id=5348c4d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5348c4d6",
  null
  
)

export default component.exports